module.exports = __webpack_public_path__ + "img/bg_11.8d42e6e7.png";